import SubRouteItineraryAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-itinerary/sub-route-itinerary.entity';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { ICreateSubRouteItinerary } from './interfaces/create-route-itinerary.interface';
import { ItineraryActionEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/itinerary-action.enum';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-subroute-itinerary-modal',
  styleUrl: './sub-route-itinerary.component.scss',
  templateUrl: './sub-route-itinerary.component.html',
  standalone: true,
  imports: [
    TranslocoModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
  ],
})
export class AddSubRouteItinerary {

  @Input() currentCreateSubRouteItinerary: any;
  @Input() daysList: any[] = [];
  @Input() actions: any[] = [];
  @Input() data: any;
  
  @Output() saveItinerary = new EventEmitter<void>();

  /* currentCreateSubRouteItinerary: ICreateSubRouteItinerary = this.initializeCreateSubRouteItinerary();
  currentUpdateSubRouteItinerary: SubRouteItineraryAttributes | undefined;

  daysList: { day: string; value: number }[] = [
    { day: 'LUNES', value: 1 },
    { day: 'MARTES', value: 2 },
    { day: 'MIÉRCOLES', value: 3 },
    { day: 'JUEVES', value: 4 },
    { day: 'VIERNES', value: 5 },
    { day: 'SÁBADO', value: 6 },
    { day: 'DOMINGO', value: 7 }
  ];

  actions: ItineraryActionEnum[] = [] */
 
  range!: FormGroup;
  isEditMode : boolean;
  constructor(
    private translocoService: TranslocoService,
    private snackBar: MatSnackBar
  ) {}
  
  ngAfterViewInit(): void {
  }

  private initializeCreateSubRouteItinerary(): ICreateSubRouteItinerary {
    return {
        days: [],
        action: [],
        datetimeStart: new Date(),
        datetimeEnd: new Date(),
    };
  }

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges() {
    if (this.currentCreateSubRouteItinerary && this.range) {
      this.updateFormValues();
    }
  }

  private initializeForm() {
    this.range = new FormGroup({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    });

    this.range.valueChanges.subscribe(value => {
      if (value.start && value.end) {
        this.currentCreateSubRouteItinerary.datetimeStart = new Date(value.start);
        this.currentCreateSubRouteItinerary.datetimeEnd = new Date(value.end);
      }
    });
  }

  private updateFormValues() {
    this.range.setValue({
      start: this.currentCreateSubRouteItinerary?.datetimeStart ?? null,
      end: this.currentCreateSubRouteItinerary?.datetimeEnd ?? null,
    }, { emitEvent: false }); 
  }

  submitForm() {
    if (this.range.valid && this.range.value.start && this.range.value.end) {
      this.currentCreateSubRouteItinerary = {
        ...this.currentCreateSubRouteItinerary,
        datetimeStart: new Date(this.range.value.start), 
        datetimeEnd: new Date(this.range.value.end), 
      };
    } else {
      this.snackBar.open("Debe seleccionar ambas fechas.","Cerrar",{ duration: 5000});
    }
  }

  save() {
    this.submitForm()
    this.saveItinerary.emit();
  }
}
